export function makeBreedString(animal){
  //include both primary and secondary breeds if set
  return [animal.breed_primary, animal.breed_secondary]
    .filter( breed => !!breed).join(",");  
}

export function makeAgeString(animal){
  //make age string
  let age = [];
  if(animal.age_years){
    age.push(animal.age_years + (animal.age_years > 1 ? " Years" : " Year"));
  }
  if(animal.age_months){
    age.push(animal.age_months + (animal.age_months > 1 ? " Months" : " Month"));
  }
  if(animal.age_weeks){
    age.push(animal.age_weeks + (animal.age_weeks > 1 ? " Weeks" : " Week"));
  }

  return age.join(", ");
}

function photoPathToUrl(uploadBase, photo, size){
  if(!photo || !photo.file){
    return false;
  }

  let photoUrl = uploadBase; 
  let pathParts = photo.file;
  pathParts = pathParts.split("/");

  if(photo.sizes[size]){
    pathParts[pathParts.length - 1] = photo.sizes[size].file;
  }

  photoUrl += "/" + pathParts.join("/");

  return photoUrl;
}

export function makePhotoUrl(uploadBase, photos, size){
  //make photo URL
  let photoUrl = "";
  size = size ? size : "medium";

  if(photos && photos.length){
    let defaultPhotos = photos.filter((photo) => photo.is_default === "1");
    let photo = defaultPhotos && defaultPhotos.length ? defaultPhotos[0] : photos[0];

    photoUrl = photoPathToUrl(uploadBase, photo, size);
  }

  return photoUrl;  
}

export function makeUrlList(uploadBase, photos, size, videos){
  let photoList = [];
  size = size ? size : "medium";


  if(photos && photos.length){
    for(var i = 0; i < photos.length; i++){
      let url = photoPathToUrl(uploadBase, photos[i], size);

      if(url){
        if(photos[i].is_default == "1"){
          photoList.unshift(url);
        }
        else{
          photoList.push(url);
        }
      }
    }
  }

  if(videos && videos.length){
    for(var i = 0; i < videos.length; i++){
      let url = makeVideoUrl(videos[i]);

      if(url){    
        if(photoList.length > 0) {
          photoList.splice(1 + i, 0, url);
        }
        else {
          photoList.push(url);     
        }
        
        //photoList.push(url);        
      }
    }
  }

  return photoList;
}

export function makeVideoUrl(videoId){
  //make video URL
  let youtubeUrl = "https://www.youtube.com/embed/";


  if(videoId && videoId.length){
   
    youtubeUrl += videoId; 
  }

  return youtubeUrl;  
}

export function updateHash(value){
  let hash = value ? "#"+value : "#";

  if(window.history.pushState) {
      window.history.pushState(null, null, hash);
  }
  else {
      window.location.hash = hash;
  }  
}

export function getAnimals(baseUrl, filters, page){

  let esc = encodeURIComponent;
  filters.page = page;
  let url = baseUrl + 'wp-json/zuri-archiver/v1/get-animals?';
  url += Object.keys(filters)
    .map(k => esc(k) + '=' + esc(filters[k]))
    .join('&');

  return fetch(url).then(response => response.json());
}